import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Observable, of } from "rxjs";
import { FeedbackTaskDetail } from "src/app/models/models";
import { ChecklistFeedbackComponent } from "./feedback/checklist-feedback.component";
import { ChecklistInstructorSignoffView } from "./ts1-staging-preview.utils";

@Component({
	selector: "app-checklist-candidate-signoff",
	templateUrl: "./checklist-candidate-signoff.component.html",
	styleUrls: ["./checklist-candidate-signoff.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ChecklistCandidateSignoffComponent {
	@Input() instructor: ChecklistInstructorSignoffView | null = null;
	@Input() candidateName = "";
	@Input() candidateSignaturePreview = "";
	@Input() candidateSignedAt = "";
	@Input() completeDisabled = true;
	@Input() signing = false;
	@Input() feedbackTask: FeedbackTaskDetail | null = null;
	@Input() feedbackPending = false;

	@Output() back = new EventEmitter<void>();
	@Output() sign = new EventEmitter<void>();
	@Output() complete = new EventEmitter<void>();
	@Output() feedbackCompleted = new EventEmitter<void>();
	@Output() feedbackFormValidChange = new EventEmitter<boolean>();

	@ViewChild(ChecklistFeedbackComponent) private feedbackComponent?: ChecklistFeedbackComponent;

	get hasCandidateSignature(): boolean {
		return !!this.candidateSignaturePreview;
	}

	get hasInstructorSignature(): boolean {
		return !!this.instructor?.signatureDataUrl;
	}

	get showFeedbackSection(): boolean {
		return !!this.feedbackTask?.template;
	}

	onFeedbackFormValidChange(valid: boolean): void {
		this.feedbackFormValidChange.emit(valid);
	}

	onFeedbackCompleted(): void {
		this.feedbackCompleted.emit();
	}

	submitFeedbackIfNeeded(): Observable<void> {
		if (!this.feedbackPending || !this.feedbackComponent) {
			return of(undefined);
		}
		return this.feedbackComponent.submit();
	}
}
